"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Banner = void 0;
const react_1 = __importStar(require("react"));
const styles_1 = require("../common/styles");
const Banner_styles_1 = require("./Banner.styles");
const Banner = (_a) => {
    var { icon, action1Text, action1, action1AriaLabel, action2Text, action2, action2AriaLabel, onClose, type = 'default', children } = _a, props = __rest(_a, ["icon", "action1Text", "action1", "action1AriaLabel", "action2Text", "action2", "action2AriaLabel", "onClose", "type", "children"]);
    const [visible, setVisible] = (0, react_1.useState)(true);
    const handleClose = (0, react_1.useCallback)(() => {
        setVisible(false);
        if (onClose) {
            onClose();
        }
    }, [onClose]);
    const useIconForAction1 = typeof action1Text === 'object';
    return (react_1.default.createElement(Banner_styles_1.StyledBannerContainer, Object.assign({}, props, { action1Text: action1Text, action1: action1, action2Text: action2Text, action2: action2, visible: visible, type: type, useIconForAction1: useIconForAction1 }),
        react_1.default.createElement(Banner_styles_1.IconTextContainer, null,
            react_1.default.createElement(styles_1.Icon, { includeMargin: true, icon: icon, type: type, "aria-hidden": true }),
            react_1.default.createElement(Banner_styles_1.StyledBody, { icon: icon }, children)),
        react_1.default.createElement(Banner_styles_1.ActionContainer, { text: action1Text, useIconForAction1: useIconForAction1 },
            action1 !== undefined ? (react_1.default.createElement(Banner_styles_1.StyledButton, { "aria-label": action1AriaLabel, mode: "flat", useIconForAction1: useIconForAction1, onClick: action1 === 'close' ? handleClose : action1 }, action1Text)) : null,
            action2 !== undefined ? (react_1.default.createElement(Banner_styles_1.StyledButton, { "aria-label": action2AriaLabel, mode: "flat", onClick: action2 === 'close' ? handleClose : action2 }, action2Text)) : null)));
};
exports.Banner = Banner;
//# sourceMappingURL=Banner.js.map